import React from 'react';
import { Modal } from 'react-bootstrap';

function CommonModal({ header, body, footer = null, show, setClose, size }) {
	return (
		<Modal className={`modal-${size}`} centered show={show} onHide={setClose}>
			<Modal.Header className='modal_header_custom' closeButton>
				<Modal.Title>{header}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{body}</Modal.Body>
			{footer !== null ? <Modal.Footer>{footer}</Modal.Footer> : null}
		</Modal>
	);
}

export default CommonModal;
